import { Close } from "@mui/icons-material";
import { IconButton, Modal, Stack, Typography } from "@mui/material";

import { desktopSx } from "src/utils/styles/modalStyles";
import PriceInformation from "../PriceInformation";
interface Props {
  open: boolean;
  onClose: () => void;
}

const CreatePriceModal = ({ onClose, open }: Props) => {
  return (
    <Modal open={open}>
      <Stack sx={desktopSx} gap={2} maxWidth={600}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5" component="h5" fontWeight={700}>
            Add Price
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <PriceInformation onClose={onClose} />
      </Stack>
    </Modal>
  );
};

export default CreatePriceModal;
